// The one HTML escape of the chrome. It is a leaf with no import, so the
// menu shell takes it without the game state that `ui/format.ts` reads.

/**
 * Escape text for interpolation into an HTML string.
 *
 * The overlay builds its panels as HTML and assigns them with innerHTML, so
 * every piece of text a *player* controls — display names, clan tags, chat —
 * has to come through here first. It escapes `'` as well as `&<>"`: no call
 * site currently interpolates into a single-quoted attribute, and the day one
 * does is not the day to discover this only covered double quotes.
 *
 * What is NOT escaped, deliberately: strings from the server's own catalog
 * (building, ship, tech, module and torpedo names) and captain names, which
 * `game/captains.go` builds from two fixed word lists. If captains ever become
 * player-nameable, `overlay.ts`'s captain row needs this function.
 */
export function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ESCAPES[c]);
}

const ESCAPES: Record<string, string> = {
  '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
};
